import { render, staticRenderFns } from "./SrReportProjectSummary.vue?vue&type=template&id=0514af35&"
import script from "./SrReportProjectSummary.vue?vue&type=script&lang=js&"
export * from "./SrReportProjectSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports